module.exports = __webpack_public_path__ + "static/media/search.69062453.svg";